
export default {
    props: {
        src: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isPlaying: false
        };
    },
    methods: {
        togglePlayPause() {
            const video = this.$refs.videoPlayer;
            if (video.paused) {
                video.play();
                this.isPlaying = true;
            } else {
                video.pause();
                this.isPlaying = false;
            }
        }
    }
}
